'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRejectedTransactionError = exports.NoWalletDetectedError = undefined;

var _constants = require('../constants');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoWalletDetectedError = exports.NoWalletDetectedError = function (_Error) {
  _inherits(NoWalletDetectedError, _Error);

  function NoWalletDetectedError() {
    var _ref;

    _classCallCheck(this, NoWalletDetectedError);

    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = NoWalletDetectedError.__proto__ || Object.getPrototypeOf(NoWalletDetectedError)).call.apply(_ref, [this].concat(params)));

    _this.name = _constants.NO_WALLET_DETECTED_ERROR;
    // Maintains proper stack trace for where our error was thrown (only available on V8).
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, NoWalletDetectedError);
    }
    return _this;
  }

  return NoWalletDetectedError;
}(Error);

var UserRejectedTransactionError = exports.UserRejectedTransactionError = function (_Error2) {
  _inherits(UserRejectedTransactionError, _Error2);

  function UserRejectedTransactionError() {
    var _ref2;

    _classCallCheck(this, UserRejectedTransactionError);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var _this2 = _possibleConstructorReturn(this, (_ref2 = UserRejectedTransactionError.__proto__ || Object.getPrototypeOf(UserRejectedTransactionError)).call.apply(_ref2, [this].concat(args)));

    _this2.name = _constants.USER_REJECTED_TRANSACTION_ERROR;
    // Maintains proper stack trace for where our error was thrown (only available on V8).
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this2, UserRejectedTransactionError);
    }
    return _this2;
  }

  return UserRejectedTransactionError;
}(Error);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/errors.js
// module id = 1232
// module chunks = 0